import { Box, Typography } from '@mui/material';

// common
import MuiLoading from 'common/components/MuiLoading';

const ExportingImage = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'white',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <MuiLoading />
      <Typography variant="h6">Đang xuất hình ảnh...</Typography>
    </Box>
  );
};

export default ExportingImage;
